import { render, staticRenderFns } from "./WxUserInfo.vue?vue&type=template&id=5b98aac4&scoped=true&"
import script from "./WxUserInfo.vue?vue&type=script&lang=js&"
export * from "./WxUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b98aac4",
  null
  
)

export default component.exports